import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.development';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  private _getTime = `${environment.base_url}/api/Time`;
  private _getFile = `${environment.base_url}/api/Files/GetFile`;
  protected readonly _http: HttpClient;
  readonly _dataServ: DataService;
  constructor() {
    this._http = inject(HttpClient);
    this._dataServ = inject(DataService);
  }
  public GetTime() {
    return this._http.get<any>(this._getTime, {
      responseType: 'string',
    } as any);
  }
  public GetFile(filePath: string, name: string) {
    return `${this._getFile}?FilePath=${filePath}&Name=${name}`;
  }
  public serializeData(obj: { [id: string]: string }) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p) && obj[p] && obj[p].trim()) {
        str.push(
          encodeURIComponent(p) + '=' + encodeURIComponent(obj[p].trim())
        );
      }
    return `?${str.join('&')}`;
  }
}
